import { setLocale } from 'yup'

import {
  ERROR_FIELD_INVALID,
  ERROR_FIELD_REQUIRED,
  ERROR_FIELD_MIN_STRING_LENGTH,
  ERROR_FIELD_MAX_STRING_LENGTH,
  ERROR_FIELD_EMAIL,
  ERROR_FIELD_MIN_DATE,
  ERROR_FIELD_MIN_ARRAY_LENGTH,
  ERROR_FIELD_MIN_NUMBER,
  ERROR_FIELD_MAX_NUMBER,
} from './formErrors'

setLocale({
  mixed: {
    default: ERROR_FIELD_INVALID,
    notType: ERROR_FIELD_INVALID,
    required: ERROR_FIELD_REQUIRED,
    oneOf: ERROR_FIELD_INVALID,
  },
  string: {
    min: ERROR_FIELD_MIN_STRING_LENGTH,
    max: ERROR_FIELD_MAX_STRING_LENGTH,
    email: ERROR_FIELD_EMAIL,
  },
  date: {
    min: ERROR_FIELD_MIN_DATE,
  },
  array: {
    min: ERROR_FIELD_MIN_ARRAY_LENGTH,
  },
  number: {
    min: ERROR_FIELD_MIN_NUMBER,
    max: ERROR_FIELD_MAX_NUMBER,
  },
})
